import '@infusionsoft/design-system/dist/style.css';

import { createApp, h } from 'vue';
import { sync } from 'vuex-router-sync';
import { createDesignSystem, components } from '@infusionsoft/design-system';
import { createDex, DexProvider } from '@thryvlabs/dex-vue';

import sentry from './analytics/sentry';
import { createFullStory } from '@keap-web/analytics-lib/fullstory';
import App from './App.vue';
import { createRouter } from './router';
import { createStore } from './store';
import { i18n } from './i18n/index';
import { createBus } from '@keap-web/shared-ui';
import { setupInterceptors } from './utils/interceptor.util';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import './styles/main.scss';

const withDex = (Component) => {
    return {
        render: () => h(DexProvider, {}, { default: () => h(Component) }),
    };
};

const app = createApp(withDex(App));
const store = createStore();
const pinia = createPinia();
const router = createRouter(store);
const designSystem = createDesignSystem({
    components,
    onOverlayActive: () => { store.commit('SET_OVERLAY_ACTIVE', true); },
    onOverlayInactive: () => { store.commit('SET_OVERLAY_ACTIVE', false); },
});
const dex = createDex();
const bus = createBus();

const fullstory = createFullStory({
    orgId: window.__KEAP__.VUE_APP_FULLSTORY_ORG,
    devMode: import.meta.env.DEV,
    enabled: import.meta.env.VUE_APP_THIRD_PARTY_LOGGING === 'enabled',
});

pinia.use(piniaPluginPersistedstate);
app.use(designSystem);
app.use(dex);
app.use(router);
app.use(store);
app.use(pinia);
app.use(i18n);
app.use(bus);
app.use(fullstory);

app.provide('rainforest', {
    paymentSrc: window.__KEAP__.VUE_APP_RAINFOREST_PAYMENT_SCRIPT_URL,
    merchantSrc: window.__KEAP__.VUE_APP_RAINFOREST_MERCHANT_SCRIPT_URL,
});

app.config.globalProperties.$number = i18n.global.n;

if (process.env.NODE_ENV !== 'development') {
    sentry.init({ app, router });
}

setupInterceptors(store);
sync(store, router);

app.mount('#app');
